import Constants from "common/constant";
import { useScale } from "common/utils";
import i18n from "features/shared/i18n";

export function FeatureHeroCards() {
  const { width, scale } = useScale();
  // 狭い画面ではプラン制限の帯を縦積みにする
  const isNarrow = width / scale < 700;
  return (
    <div className="flex-col-el gap-6 [word-break:auto-phrase]">
      <div className="bg-gradient-to-r from-[#E8F5E9] to-[#C8E6C9] rounded-[20px] p-8 shadow-lg">
        <div className="flex-row-el gap-8">
          <div className="flex-col-el items-center justify-center w-[120px] h-[120px] bg-white rounded-[20px] shadow-md shrink-0">
            <img
              alt="まなパルくん"
              src={`${Constants.assetHost}/assets/images/little_pal.png`}
              className="w-[100px] h-[100px] object-contain"
            />
          </div>

          <div className="flex-1 flex-col-el gap-4">
            <div className="text-[36px] text-textcolor-black">
              {i18n.t("MSG_PARENT_PAGE_AI_CHAT_FEATURE")}
            </div>
            <div className="text-[27px] text-textcolor-black">
              {i18n.t("MSG_PARENT_PAGE_AI_CHAT_TAGLINE")}
            </div>
            <div className="flex-col-el gap-2 leading-[32px]">
              <div className="flex-row-el items-start gap-2">
                <span className="material-symbols-outlined text-[30px] text-[#66BB6A] flex items-center h-[32px] translate-y-[4px]">
                  check_circle
                </span>
                <span className="text-[24px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1")}
                </span>
              </div>
              <div className="flex-row-el items-start gap-2">
                <span className="material-symbols-outlined text-[30px] text-[#66BB6A] flex items-center h-[32px] translate-y-[4px]">
                  check_circle
                </span>
                <span className="text-[24px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2")}
                </span>
              </div>
              <div className="flex-row-el items-start gap-2">
                <span className="material-symbols-outlined text-[30px] text-[#66BB6A] flex items-center h-[32px] translate-y-[4px]">
                  check_circle
                </span>
                <span className="text-[24px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3")}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            isNarrow
              ? "flex-col-el mt-6 rounded-[12px] overflow-hidden"
              : "flex-row-el mt-6 rounded-[12px] overflow-hidden"
          }
        >
          <div className="flex-1 flex-row-el items-center justify-center gap-2 py-3 bg-gray2-40">
            <span className="text-[21px] text-gray2-100">
              {i18n.t("MSG_PLAN_FREE_FULL_PARENT")}:
            </span>
            <span className="text-[24px] text-gray2-100">
              {i18n.t("MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT")}
            </span>
          </div>
          <div className="flex-1 flex-row-el items-center justify-center gap-2 py-3 bg-[#66BB6A]/20">
            <span className="text-[21px] text-[#66BB6A]">
              {i18n.t("MSG_PLAN_STANDARD_FULL_PARENT")}:
            </span>
            <span className="text-[24px] text-[#66BB6A]">
              {i18n.t("MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT")}
            </span>
          </div>
          <div className="flex-1 flex-row-el items-center justify-center gap-2 py-3 bg-[#FF5722]/20">
            <span className="text-[21px] text-[#FF5722]">
              {i18n.t("MSG_PLAN_PREMIUM_FULL_PARENT")}:
            </span>
            <span className="text-[24px] text-[#FF5722]">
              {i18n.t("MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT")}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-[#E3F2FD] to-[#BBDEFB] rounded-[20px] p-8 shadow-lg">
        <div className="flex-row-el gap-8">
          <div className="flex-col-el items-center justify-center w-[120px] h-[120px] bg-white rounded-[20px] shadow-md shrink-0">
            <span className="material-symbols-outlined !text-8xl text-[#42A5F5]">auto_awesome</span>
          </div>

          <div className="flex-1 flex-col-el gap-4">
            <div className="text-[36px] text-textcolor-black">
              {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_FEATURE")}
            </div>
            <div className="text-[27px] text-textcolor-black">
              {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_TAGLINE")}
            </div>
            <div className="flex-col-el gap-2 leading-[32px]">
              <div className="flex-row-el items-start gap-2">
                <span className="material-symbols-outlined text-[30px] text-[#42A5F5] flex items-center h-[32px] translate-y-[4px]">
                  check_circle
                </span>
                <span className="text-[24px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1")}
                </span>
              </div>
              <div className="flex-row-el items-start gap-2">
                <span className="material-symbols-outlined text-[30px] text-[#42A5F5] flex items-center h-[32px] translate-y-[4px]">
                  check_circle
                </span>
                <span className="text-[24px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2")}
                </span>
              </div>
              <div className="flex-row-el items-start gap-2">
                <span className="material-symbols-outlined text-[30px] text-[#42A5F5] flex items-center h-[32px] translate-y-[4px]">
                  check_circle
                </span>
                <span className="text-[24px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3")}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            isNarrow
              ? "flex-col-el mt-6 rounded-[12px] overflow-hidden"
              : "flex-row-el mt-6 rounded-[12px] overflow-hidden"
          }
        >
          <div className="flex-1 flex-row-el items-center justify-center gap-2 py-3 bg-gray2-40">
            <span className="text-[21px] text-gray2-100">
              {i18n.t("MSG_PLAN_FREE_FULL_PARENT")}:
            </span>
            <span className="text-[24px] text-gray2-100">
              {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT")}
            </span>
          </div>
          <div className="flex-1 flex-row-el items-center justify-center gap-2 py-3 bg-[#66BB6A]/20">
            <span className="text-[21px] text-[#66BB6A]">
              {i18n.t("MSG_PLAN_STANDARD_FULL_PARENT")}:
            </span>
            <span className="text-[24px] text-[#66BB6A]">
              {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT")}
            </span>
          </div>
          <div className="flex-1 flex-row-el items-center justify-center gap-2 py-3 bg-[#FF5722]/20">
            <span className="text-[21px] text-[#FF5722]">
              {i18n.t("MSG_PLAN_PREMIUM_FULL_PARENT")}:
            </span>
            <span className="text-[24px] text-[#FF5722]">
              {i18n.t("MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
